export class CaseType {
    id: number;
    typeName: string;
    isDeleted: boolean;
    mainDataTitle: string;
    mainDataReport: boolean;
    addresses: boolean;
    evidence: boolean;
    mainDataAttachment: boolean;
    investigationTitle: string;
    violations: boolean;
    investigationRecords: boolean;
    concealmentInMembers: boolean;
    investigationAttachment: boolean;
    inspectionTitle: string;
    inspectionRecords: boolean;
    inspectionAttachment: boolean;
    recallsTitle: string;
    recallsRecords: boolean;
    qandARecords: boolean;
    recallsAttachments: boolean;
    reportTitle: string;
    sendToProsecution: boolean;
    sendToCommittee: boolean;
    depositOrders: boolean;
    externalActions: boolean;
    finds: boolean;
    accountStatments: boolean;
    relatedCases: boolean;
    generalAttachments: boolean;
    allowPerson: boolean;
    createdBy: number;
    createdOn: string;
    modifiedBy: number;
    modifiedOn: string;
    committeeIds: number[];
    processId: number;
    processName: string;
    eCaseTypeId: string;
    constructor() {
      this.id = 0;
      this.typeName = '';
      this.isDeleted =  false;
      this.mainDataTitle = '';
      this.mainDataReport = false;
      this.addresses = false;
      this.evidence = false;
      this.mainDataAttachment = false;
      this.investigationTitle = '';
      this.violations = false;
      this.investigationRecords = false;
      this.concealmentInMembers = false;
      this.investigationAttachment = false;
      this.inspectionTitle = '';
      this.inspectionRecords = false;
      this.inspectionAttachment = false;
      this.recallsTitle = '';
      this.recallsRecords = false;
      this.qandARecords = false;
      this.recallsAttachments = false;
      this.reportTitle = '';
      this.sendToProsecution = false;
      this.sendToCommittee = false;
      this.depositOrders = false;
      this.externalActions = false;
      this.finds = false;
      this.accountStatments = false;
      this.relatedCases = false;
      this.generalAttachments = false;
      this.allowPerson =  false;
      this.createdBy = 0;
      this.createdOn = '';
      this.modifiedBy = 0;
      this.modifiedOn = '';
      this.committeeIds =  [];
      this.processId = 0;
      this.processName = '';
      this.eCaseTypeId = '';
    }
  }
  